import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { AlertasComponent } from 'src/app/alertas/alertas.component';
@Component({
  selector: 'app-affiliate-check',
  templateUrl: './affiliate-check.component.html',
  styleUrls: ['./affiliate-check.component.sass']
})
export class AffiliateCheckComponent implements OnInit {
  public tiposPagos;
  public bankCode = '';
  public bankAccountNo = '';
  public nameOnCard = '';
  // public expDate = '';
  public months;
  public years;
  public bank = '*';
  public selectBan = atob(sessionStorage.getItem("selectBan"));
  public token: string = sessionStorage.getItem("token");
  @Input() infoAfiliation;
  @Input() tiposPago;
  @Input() screen;
  @Output() updateScreen = new EventEmitter();
  @Output() updatetipo = new EventEmitter();
  constructor(private services: Service, private loadingScreenService: LoadingScreenService, private global: GlobalService) { }

  ngOnInit() {
    this.tiposPagos = [{
      value: 'CC',
      label: 'Tarjeta de Crédito'
    }, {
      value: 'CH',
      label: 'Cuenta de Cheques'
    }];
    this.tiposPago = this.tiposPagos[0].value;
    this.months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    this.years = [];
  }

  cambiarTipoPago() {
    if (this.global.validateSession() === true) {
      if (this.tiposPago === 'CC') {
        this.screen = 4;
      }
      else {
        this.screen = 2;
      }
      this.updateScreen.emit(this.screen);
      this.updatetipo.emit(this.tiposPago);
    }
  }
  debitAccount() {
    if (this.global.validateSession() === true) {
      if (this.validarCheque() === true) {
        // this.expDate = this.selectedYear + '-'+ this.selectedMonth;
        var startDate = null;
        var endDate = null;
        var cardNum = null;
        var status = 'A';
        var tipoTDC = null;
        var fechaVencimiento = null;
        this.loadingScreenService.startLoading();
        this.services.updateDirectDebit(this.token, this.tiposPago, cardNum, this.nameOnCard, tipoTDC, fechaVencimiento, startDate, this.bankAccountNo, endDate, this.bankCode, this.selectBan, status).subscribe(data => {
          this.loadingScreenService.stopLoading();
          if (data.HasError == false) {
            this.screen = 3;
            this.infoAfiliation.type = 'Cuenta de Cheques';
            this.codeBank(this.bankCode);
            this.infoAfiliation.mAccountNo = this.convertNum(this.bankAccountNo);
            this.updateScreen.emit(this.screen);
          }
          else {
            this.global.notif(data.ErrorDesc);
          }
        });
      }
    }
  }
  codeBank(code) {
    if (this.global.validateSession() === true) {
      if (code === '021502011') {
        this.bank = 'Banco Popular of Puerto Rico';
      }
      else if (code === '021502341') {
        this.bank = 'Banco Santander of Puerto Rico';
      }
      else if (code === '221571473') {
        this.bank = 'Firstbank, P.R.';
      }
      else if (code === '021502804') {
        this.bank = 'Scotiabank of Puerto Rico';
      }
      else if (code === '221571415') {
        this.bank = 'Oriental Bank';
      }
      else if (code === '221582284') {
        this.bank = 'COOP. MANATI';
      }
      else if (code === '021582785') {
        this.bank = 'COOP. ISABELA';
      }
      else if (code === '021583658') {
        this.bank = 'COOP.ENERGIA ELECTRICA';
      }
      else if (code === '021582727') {
        this.bank = 'COOP. SAGRADA FAMILIA';
      }
      else if (code === '021582853') {
        this.bank = 'COOP. LAS PIEDRAS';
      }
      else if (code === '221582226') {
        this.bank = 'COOP. CAMUY';
      }
      else if (code === '221581706') {
        this.bank = 'COOP. MOCA';
      }
      else if (code === '021583247') {
        this.bank = 'COOP. SABANENA';
      }
      else if (code === '221582459') {
        this.bank = 'COOP.LA PUERTORRIQUENA';
      }
      else if (code === '267089712') {
        this.bank = 'FIRST BANK US V.G.';
      }
      else if (code === '221581641') {
        this.bank = 'COOP. ARECIBO';
      }
      else if (code === '021582743') {
        this.bank = 'COOP. SAN JOSE';
      }
      else if (code === '021584217') {
        this.bank = 'COOP. LOS HERMANOS';
      }
      else if (code === '021582976') {
        this.bank = 'COOP. AGUADA';
      }
      else if (code === '021583373') {
        this.bank = 'COOP.BARRIO QUEBRADA';
      }
      else if (code === '021583593') {
        this.bank = 'COOP. VILLALBA';
      }
      else if (code === '021583137') {
        this.bank = 'COOP. ANASCO';
      }
      else if (code === '021583360') {
        this.bank = 'COOP. MAYAGUEZ';
      }
      else if (code === '221672851') {
        this.bank = 'FIRST BANK US V.I.';
      }
      else if (code === '221581751') {
        this.bank = 'COOP. VALENCIANO';
      }
      else if (code === '221581722') {
        this.bank = 'COOP. MAUNABO';
      }
      else if (code === '221582077') {
        this.bank = 'COOP. JAYUYA';
      }
      else if (code === '021583111') {
        this.bank = 'COOP. SAN BLAS';
      }
      else if (code === '021583140') {
        this.bank = 'COOP. NAGUABENA';
      }
      else if (code === '021582662') {
        this.bank = 'COOP. CAGUAS';
      }
      else if (code === '021583328') {
        this.bank = 'COOP. CAPARRA';
      }
      else if (code === '021583056') {
        this.bank = 'COOP. CIALES';
      }
      else if (code === '021583027') {
        this.bank = 'COOP. VEGA ALTA';
      }
      else if (code === '021582756') {
        this.bank = 'COOP. AGUAS BUENAS';
      }
      else if (code === '221581748') {
        this.bank = 'COOP. ORIENTAL';
      }
      else if (code === '221582310') {
        this.bank = 'COOP. CABO ROJO';
      }
      else if (code === '021582701') {
        this.bank = 'COOP. GURABO';
      }
      else if (code === '021583483') {
        this.bank = 'COOP. PARROCOOP';
      }
      else if (code === '221582174') {
        this.bank = 'COOP. YAUCO';
      }
      else if (code === '021502040') {
        this.bank = 'CITIBANK';
      }
      else if (code === '221582323') {
        this.bank = 'HATICOOP';
      }
    }
  }
  convertNum(num) {
    try {
      return num.substr(num.length - 4);
    }
    catch (error) {
      return "***";
    }

  }
  validarCheque() {
    var sw = true;
    if (this.bankCode === '') {
      this.global.notif("Debe colocar un código de banco");
      sw = false;
    }
    else if (this.bankAccountNo === '') {
      this.global.notif("Debe colocar un número de cuenta");
      sw = false;
    }
    return sw;
  }
}
